/**
 * Componente AddStudent
 * Gerencia o cadastro de novos alunos com informações pessoais, responsáveis e oficinas
 */

import  { useState, useEffect } from "react";
import api from "../../../services/api";
import ResponsibleModal from "../Modal/Responsible/ResponsibleModal";
import "./AddStudent.css";
import { FaChalkboardTeacher, FaSearch, FaTools, FaUser, FaUserCircle } from "react-icons/fa";
import Cookies from 'js-cookie';
import { FaHouse } from "react-icons/fa6";

function AddStudent() {
  const [fullName, setFullName] = useState(""); // Novo estado para nome completo
  const [birthdate, setBirthdate] = useState("");
  const [gender, setGender] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [street, setStreet] = useState("");
  const [number, setNumber] = useState("");
  const [complement, setComplement] = useState("");
  const [neighborhood, setNeighborhood] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [motherName, setMotherName] = useState("");
  const [responsibles, setResponsibles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [canGoHomeAlone, setCanGoHomeAlone] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [categoriesPerPage] = useState(15);
  const [idPcd, setIdPcd] = useState(false);
  const [disabilityType, setDisabilityType] = useState("");
  const [disabilityReport, setDisabilityReport] = useState(null);
  const [disabilityReportName, setDisabilityReportName] = useState("");
  const [fileError, setFileError] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [photoFile, setPhotoFile] = useState(null);
  const [photoError, setPhotoError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  /**
   * Carrega categorias/oficinas disponíveis
   */
  const fetchCategories = async () => {
    try {
      const response = await api.get("/categories/index?page=1&limit=99999");
      const sortedCategories = response.data.data.sort((a, b) => a.name.localeCompare(b.name));
      setCategories(sortedCategories);
    } catch (error) {
      console.error("Erro ao buscar Oficina:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleCategoryChange = (categoryId) => {
    setSelectedCategories((prevSelectedCategories) => {
      if (prevSelectedCategories.includes(categoryId)) {
        return prevSelectedCategories.filter((id) => id !== categoryId);
      } else {
        return [...prevSelectedCategories, categoryId];
      }
    });
  };

  const handleCepChange = (e) => {
    setZipCode(e.target.value);
  };

  /**
   * Busca endereço por CEP usando API externa
   */
  const fetchAddressByCep = async () => {
    const cep = zipCode.replace(/\D/g, "");
    if (cep.length === 8) {
      try {
        const response = await fetch(
          `https://viacep.com.br/ws/${cep}/json/`
        );
        if (response.ok) {
          const data = await response.json();
          if (!data.erro) {
            setStreet(data.logradouro || "");
            setComplement(data.complemento || "");
            setNeighborhood(data.bairro || "");
            setCity(data.localidade || "");
            setState(data.uf || "");
          } else {
            console.error("CEP não encontrado");
            alert("CEP não encontrado.");
          }
        } else {
          console.error("Erro na requisição");
          alert("Erro ao buscar CEP. Por favor, verifique sua conexão.");
        }
      } catch (error) {
        console.error("Erro ao buscar CEP:", error);
        alert("Erro ao buscar CEP. Por favor, tente novamente.");
      }
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const maxSize = 5 * 1024 * 1024;
    if (file && file.type !== "application/pdf") {
      setFileError("Por favor, anexe um arquivo PDF.");
      setDisabilityReport(null);
      setDisabilityReportName("");
    } else if (file && file.size > maxSize) {
      setFileError("O tamanho do arquivo não pode exceder 5MB.");
      setDisabilityReport(null);
      setDisabilityReportName("");
    } else if (file) {
      setFileError("");
      setDisabilityReport(file);
      setDisabilityReportName(file.name);
    }
  };

  const handlePhotoChange = (e) => {
    const file = e.target.files[0];
    const allowedTypes = ["image/jpeg", "image/jpg", "image/png", "image/gif"];
    const maxSize = 2 * 1024 * 1024;
    if (file && !allowedTypes.includes(file.type)) {
      setPhotoError("Formato inválido. Use JPEG, JPG, PNG ou GIF.");
      setPhotoFile(null);
    } else if (file && file.size > maxSize) {
      setPhotoError("Tamanho máximo 2MB.");
      setPhotoFile(null);
    } else {
      setPhotoError("");
      setPhotoFile(file);
    }
  };

  const handleRemoveFile = () => {
    setDisabilityReport(null);
    setDisabilityReportName("");
    setFileError("");
  };

  /**
   * Submete formulário de cadastro do aluno
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return; // Previne múltiplas submissões
    setIsSubmitting(true);

    // Quebra o nome completo do aluno em partes
    const nameParts = fullName.trim().split(" ");
    const firstName = nameParts[0] || "";
    const lastName = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";

    let responsiblesToSend = [...responsibles];

    try {
      // Enviar dados do aluno como JSON
      const studentData = {
        first_name: firstName,
        last_name: lastName,
        birthdate: birthdate,
        gender: gender,
        phone_number: phoneNumber,
        street: street,
        number: number,
        complement: complement,
        neighborhood: neighborhood,
        city: city,
        state: state,
        zip_code: zipCode,
        father_name: fatherName,
        mother_name: motherName,
        can_go_home_alone: canGoHomeAlone,
        category_ids: selectedCategories,
        responsibles: responsiblesToSend,
        id_pcd: idPcd,
      };

      const response = await api.post("/student/create", studentData, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Controller retorna {data: StudentResource}, então ID está em data.data.id
      const studentId = response.data.data.id;

      // Enviar arquivo PDF separadamente, se existir
      if (disabilityReport) {
        const formData = new FormData();
        formData.append("pdf_attachment", disabilityReport);

        await api.post(`/student/${studentId}/upload-pdf`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }

      if (photoFile) {
        try {
          const formData = new FormData();
          formData.append("photo", photoFile);
          
          await api.post(`/student/${studentId}/upload-photo`, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
        } catch (err) {
          console.error('Erro ao enviar foto:', err);
          alert('Aluno criado, mas erro ao enviar foto.');
        }
      }

      alert("Aluno criado com sucesso!");
      const storedStudents = JSON.parse(Cookies.get("studentsData") || "[]");
      const updatedStudents = [...storedStudents, studentData];
      Cookies.set("studentsData", JSON.stringify(updatedStudents), { secure: true });

      // Reset form fields
      setFullName(""); // Limpa o nome completo
      setBirthdate("");
      setGender(true);
      setPhoneNumber("");
      setStreet("");
      setNumber("");
      setComplement("");
      setNeighborhood("");
      setCity("");
      setState("");
      setZipCode("");
      setFatherName("");
      setMotherName("");
      setCanGoHomeAlone(false);
      setResponsibles([]);
      setIdPcd(false);
      setDisabilityType("");
      setDisabilityReport(null);
      setDisabilityReportName("");
      setPhotoFile(null);
      setPhotoError("");
      setSelectedCategories([]);

      // Recarrega as categorias após o submit
      fetchCategories();

      window.scrollTo({ top: 0, behavior: 'smooth' });

    } catch (error) {
      console.error("Erro ao criar aluno:", error);
      alert("Erro ao criar aluno!");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEditResponsible = (index) => {
    setShowModal({ show: true, responsibleIndex: index });
  };

  const handleAddResponsibleClick = () => {
    setShowModal({ show: true });
  };

  const handleRemoveResponsible = (index) => {
    setResponsibles(responsibles.filter((_, i) => i !== index));
  };

  const indexOfLastCategory = currentPage * categoriesPerPage;
  const indexOfFirstCategory = indexOfLastCategory - categoriesPerPage;
  const filteredCategories = categories.filter(category =>
    category.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const currentCategories = filteredCategories.slice(indexOfFirstCategory, indexOfLastCategory);

  const handleNextPage = () => {
    if (currentPage < Math.ceil(categories.length / categoriesPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(categories.length / categoriesPerPage); i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="add-student-container">
      <form onSubmit={handleSubmit} className="student-form">
        <h1 style={{ textAlign: 'center' }}>Criar Aluno</h1>
        <p style={{ textAlign: 'center' }}>* Campos obrigatórios</p>
        <fieldset>
          <legend>
            <FaUser /> Dados pessoais
          </legend>
          <div className="form-group-inline">
            <div className="form-group">
              <label htmlFor="full-name">Nome completo: *</label>
              <input
                type="text"
                id="full-name"
                value={fullName}
                onChange={(e) => setFullName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="birthdate">Data de Nascimento: *</label>
              <input
                type="date"
                id="birthdate"
                value={birthdate}
                onChange={(e) => setBirthdate(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-group-inline">
            <div className="form-group">
              <label htmlFor="gender">Gênero: *</label>
              <select
                id="gender"
                value={gender}
                onChange={(e) => setGender(e.target.value === "true")}
                required
              >
                <option value={true}>Masculino</option>
                <option value={false}>Feminino</option>
              </select>
            </div>
            <div className="form-group">
              <label htmlFor="phone">Número de Telefone: *</label>
              <input
                type="tel"
                id="phone"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                required
              />
            </div>
          </div>

          <div className="form-group-inline">
            <div className="form-group">
              <label htmlFor="mother-name">Nome da Mãe: *</label>
              <input
                type="text"
                id="mother-name"
                value={motherName}
                onChange={(e) => setMotherName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="father-name">Nome do Pai:</label>
              <input
                type="text"
                id="father-name"
                value={fatherName}
                onChange={(e) => setFatherName(e.target.value)}
              />
            </div>
          </div>          <div className="form-group">
            <label>Foto do Aluno:</label>
            <div className="student-photo-preview">
              <div className="student-photo-container">
                {photoFile ? (
                  <img 
                    src={URL.createObjectURL(photoFile)} 
                    alt="Pré-visualização da foto" 
                    className="student-photo-image" 
                  />
                ) : (
                  <FaUserCircle size={80} className="student-photo-placeholder" />
                )}
              </div>
              <div className="student-photo-upload-controls">
                <label className="student-photo-upload-btn" htmlFor="photo-upload">
                  {photoFile ? 'Alterar foto' : 'Selecionar foto'}
                </label>
                <input
                  id="photo-upload"
                  type="file"
                  accept=".jpeg,.jpg,.png,.gif"
                  onChange={handlePhotoChange}
                  style={{ display: 'none' }}
                />
                {photoFile && (
                  <button
                    type="button"
                    className="student-photo-remove-btn"
                    onClick={() => setPhotoFile(null)}
                  >
                    Remover
                  </button>
                )}
              </div>
              {photoError && <p className="student-file-error">{photoError}</p>}
            </div>
          </div>
        </fieldset>

        <fieldset>
          <legend className="student-color:black;">
            <FaHouse /> Endereço:
          </legend>
          <div className="form-group-inline">
            <div className="form-group">
              <label htmlFor="zip-code">CEP: *</label>
              <div className="cep-input-group">
                <input
                  type="text"
                  id="zip-code"
                  value={zipCode}
                  onChange={handleCepChange}
                  required
                />
                <button type="button" onClick={fetchAddressByCep}>
                  <FaSearch />
                </button>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="street">Rua: *</label>
              <input
                type="text"
                id="street"
                value={street}
                onChange={(e) => setStreet(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="number">Número: *</label>
              <input
                type="text"
                id="number"
                value={number}
                onChange={(e) => setNumber(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="form-group-inline">
            <div className="form-group">
              <label htmlFor="complement">Complemento:</label>
              <input
                type="text"
                id="complement"
                value={complement}
                onChange={(e) => setComplement(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label htmlFor="neighborhood">Bairro: *</label>
              <input
                type="text"
                id="neighborhood"
                value={neighborhood}
                onChange={(e) => setNeighborhood(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="city">Cidade: *</label>
              <input
                type="text"
                id="city"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="state">Estado: *</label>
              <input
                type="text"
                id="state"
                value={state}
                onChange={(e) => setState(e.target.value)}
                required
              />
            </div>
          </div>
        </fieldset>

        <fieldset>
          <legend>
            <FaChalkboardTeacher /> Informações Adicionais
          </legend>
          <div className="form-group-inline">
            <div className="form-group">
              <label htmlFor="id-pcd">PCD?</label>
              <select
                id="id-pcd"
                value={idPcd}
                onChange={(e) => setIdPcd(e.target.value === "true")}
              >
                <option value={false}>Não</option>
                <option value={true}>Sim</option>
              </select>
            </div>
            {idPcd && (
              <>
                <div className="form-group">
                  <label htmlFor="disability-type">Informe o PCD:</label>
                  <input
                    type="text"
                    id="disability-type"
                    value={disabilityType}
                    onChange={(e) => setDisabilityType(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="disability-report" style={{ marginLeft: '20px' }}>Anexar Laudo:</label>
                  <input
                    className="student-file-input"
                    type="file"
                    id="disability-report"
                    onChange={handleFileChange}
                    accept="application/pdf"
                  />
                  <label htmlFor="disability-report" className="file-label">
                    Escolher arquivo
                  </label>
                  {disabilityReportName && (
                    <div className="student-file-info">
                      <p className="student-file-name"> {disabilityReportName}</p>
                      <button type="button" className="student-remove-file" onClick={handleRemoveFile}>
                        Remover Laudo
                      </button>
                    </div>
                  )}
                  {fileError && (
                    <p className="student-file-error">{fileError}</p>
                  )}
                </div>
              </>
            )}

          </div>
          <div className="student-category-checkbox-group">
            <label htmlFor="can-go-home-alone">
              <input
                type="checkbox"
                id="can-go-home-alone"
                checked={canGoHomeAlone}
                onChange={(e) => setCanGoHomeAlone(e.target.checked)}
              />
              Pode ir para casa sozinho?
            </label>
          </div>
        </fieldset>

        <fieldset>
          <legend> <FaTools />  Oficinas</legend>
          <div className="form-group">
            <label>Pesquisar Oficinas:</label>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Digite o nome da oficina"
            />
          </div>
          <div className="form-group">
            <label>Oficinas:</label>
            <div className="category-checkbox-group">
              {currentCategories.map((category) => (
                <div key={category.id} className="category-checkbox-item">
                  <input
                    type="checkbox"
                    id={`category-${category.id}`}
                    name="category"
                    value={category.id}
                    checked={selectedCategories.includes(category.id)}
                    onChange={() => handleCategoryChange(category.id)}
                  />
                  <label htmlFor={`category-${category.id}`}>{category.name}</label>
                </div>
              ))}
            </div>

            <div className="pagination">
              <button type="button" onClick={handlePreviousPage} className="student-page-link">
                Anterior
              </button>
              <span className="student-page-info">
                Página {currentPage} / {Math.ceil(filteredCategories.length / categoriesPerPage)}
              </span>
              <button type="button" onClick={handleNextPage} className="student-page-link">
                Próxima
              </button>
            </div>
          </div>
        </fieldset>

        <button
          type="button"
          className="add-responsible"
          onClick={handleAddResponsibleClick}
        >
          Adicionar Responsável
        </button>
        <div className="sudent-form">

          {responsibles.length > 0 && (
            <div className="responsibles-list">
              <h2>Responsáveis:</h2>
              <ul>
                {responsibles.map((responsible, index) => (
                  <li key={index}>
                    {responsible.first_name} {responsible.last_name}
                    <div className="responsible-actions">
                      <button
                        type="button"
                        onClick={() => handleEditResponsible(index)}
                      >
                        Editar
                      </button>
                      <button
                        type="button"
                        onClick={() => handleRemoveResponsible(index)}
                      >
                        Remover
                      </button>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          )}

        </div>
        <div className="form-group">
          <button type="submit" className="create-student" disabled={isSubmitting}>
            {isSubmitting ? 'Criando aluno...' : 'Criar Aluno'}
          </button>
        </div>
      </form>

      {showModal && (
        <ResponsibleModal
          setShowModal={setShowModal}
          setResponsibles={setResponsibles}
          responsibles={responsibles}
          responsibleIndex={showModal.responsibleIndex}
        />
      )}
    </div>
  );
}

export default AddStudent;